import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider, useAuth } from './contexts/AuthContext';
import { ErrorProvider } from './contexts/ErrorContext';
import Layout from './components/layout/Layout';
import AuthPage from './pages/Auth/AuthPage';
import InvitePage from './pages/Auth/InvitePage';
import Dashboard from './pages/Dashboard/Dashboard';
import KidDetail from './pages/KidDetail/KidDetail';
import Settings from './pages/Settings/Settings';

const ProtectedRoute = ({ children }) => {
  const { user, loading } = useAuth();
  if (loading) return <div className="min-h-screen flex items-center justify-center p-8">Loading app secure state...</div>;
  if (!user) return <Navigate to="/auth" />;
  return children;
};

function App() {
  return (
    <ErrorProvider>
      <AuthProvider>
        <Router>
          <Routes>
            <Route path="/auth" element={<AuthPage />} />
            <Route path="/invite/:token" element={<InvitePage />} />
            <Route path="/" element={<ProtectedRoute><Layout /></ProtectedRoute>}>
              <Route index element={<Dashboard />} />
              <Route path="kid/:id" element={<KidDetail />} />
              <Route path="settings" element={<Settings />} />
            </Route>
          </Routes>
        </Router>
      </AuthProvider>
    </ErrorProvider>
  );
}

export default App;